import { Accordion as MUIAccordion } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledAccordion = withStyles(() => ({
  root: {
    border: 'none',
    borderBottom: '0.0625rem solid #F1F1F1',
    boxSizing: 'border-box',
    boxShadow: 'none',

    '& .MuiAccordionSummary-content': {
      margin: '0'
    },

    '&:before': {
      display: 'none'
    },

    '& .MuiAccordionSummary-root.Mui-focused': {
      backgroundColor: 'transparent'
    }
  }
}))(MUIAccordion)

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },

  heading: {
    fontSize: theme.size.base
  }
}))

export default useStyles
